import { RouteName } from 'frontend/_setup/setupRouter/types/RouteName'
import { ResourceSectionType } from 'frontend/common/layout/enum/resource-section-type'
import { ISidebarNavigationItem } from 'frontend/common/layout/types/i-sidebar-navigation-item'

import { ColorType } from '../types/color-type-enum'

export function getSidebarNavigationItems(slug: string): ISidebarNavigationItem[] {
  return [
    {
      link: `/events/${slug}/dispatcher-screen`,
      iconClasses: 'mi-outlined mi-settings-input-component',
      subscript: 'D',
      title: 'Dispatcher',
      sectionType: ResourceSectionType.OperationalModules,
    },
    {
      link: `/events/${slug}/shifts-manager-screen`,
      iconClasses: 'mi-outlined mi-groups',
      subscript: 'SM',
      title: 'Shifts Manager',
      sectionType: ResourceSectionType.OperationalModules,
    },
    {
      link: `/events/${slug}/live-panel`,
      iconClasses: 'mi-outlined mi-satellite',
      subscript: 'LP',
      title: 'Live Panel',
      sectionType: ResourceSectionType.OperationalModules,
    },
    // {
    //   link: {
    //     name: RouteName.ClientCommunication,
    //   },
    //   iconClasses: 'mi-outlined mi-textsms',
    //   title: 'Client Communication',
    //   sectionType: ResourceSectionType.OperationalModules,
    //   subItems: [
    //     {
    //       link: {
    //         name: RouteName.ClientCommunicationTemplates,
    //       },
    //       title: 'Templates',
    //       iconClasses: null,
    //       sectionType: null,
    //     },
    //     {
    //       link: {
    //         name: RouteName.ClientCommunicationRules,
    //       },
    //       title: 'Rules',
    //       iconClasses: null,
    //       sectionType: null,
    //     },
    //     {
    //       link: {
    //         name: RouteName.ClientCommunicationMessages,
    //       },
    //       title: 'Messages',
    //       iconClasses: null,
    //       sectionType: null,
    //     },
    //   ],
    // },
    {
      link: `/events/${slug}/system-notifications`,
      iconClasses: 'mi-outlined mi-notification-important',
      title: 'System Notifications',
      sectionType: ResourceSectionType.OperationalModules,
    },
    {
      link: {
        name: RouteName.BusModule,
      },
      iconClasses: 'mi-outlined mi-directions-bus',
      title: 'Bus Module',
      sectionType: ResourceSectionType.OperationalModules,
      subItems: [
        {
          link: {
            name: RouteName.BusModuleRoutes,
          },
          title: 'Routes',
          iconClasses: null,
          sectionType: null,
        },
        {
          link: {
            name: RouteName.BusModuleSubsystems,
          },
          title: 'Subsystems',
          iconClasses: null,
          sectionType: null,
        },
        {
          link: {
            name: RouteName.BusTimetables,
          },
          title: 'Timetables',
          iconClasses: null,
          sectionType: null,
        },
        {
          link: {
            name: RouteName.BusModuleAllocations,
          },
          title: 'Allocations',
          iconClasses: null,
          sectionType: null,
        },
      ],
    },
    // {
    //   link: `/events/${slug}/transport-bookings`,
    //   iconClasses: 'mi-outlined mi-commute',
    //   title: 'Transport Bookings',
    //   sectionType: ResourceSectionType.Demand,
    // },
    // {
    //   link: `/events/${slug}/batch-onsite-requests`,
    //   iconClasses: 'mi-outlined mi-mode-of-travel',
    //   subscript: 'BOR',
    //   title: 'Batch On-Site Requests',
    //   sectionType: 'Demand',
    // },
    {
      link: `/events/${slug}/all-demands`,
      iconClasses: 'mi-outlined mi-all-inclusive',
      title: 'All Demands',
      sectionType: ResourceSectionType.Demand,
    },
    // {
    //   link: `/events/${slug}/shift-jobs`,
    //   iconClasses: 'mi-outlined mi-work-history',
    //   title: 'Shift Jobs',
    //   sectionType: ResourceSectionType.Demand,
    // },
    // {
    //   link: `/events/${slug}/transfer-groups`,
    //   iconClasses: 'mi-outlined mi-group-add',
    //   title: 'Transfer Groups',
    //   sectionType: ResourceSectionType.Demand,
    // },
    {
      link: `/events/${slug}/shuttle-transfers`,
      iconClasses: 'mi-outlined mi-directions-bus',
      shouldShowSubScript: true,
      title: 'Shuttle Transfers',
      sectionType: ResourceSectionType.Demand,
    },
    {
      link: `/events/${slug}/vehicles`,
      iconClasses: 'mi-outlined mi-directions-car',
      title: 'Vehicles',
      sectionType: ResourceSectionType.Resources,
    },
    {
      link: `/events/${slug}/drivers`,
      iconClasses: 'mi-outlined mi-badge',
      title: 'Drivers',
      sectionType: ResourceSectionType.Resources,
    },
    {
      link: `/events/${slug}/clients`,
      iconClasses: 'mi-outlined mi-recent-actors',
      title: 'Clients',
      sectionType: ResourceSectionType.Resources,
    },
    {
      link: `/events/${slug}/shifts`,
      iconClasses: 'mi-outlined mi-change-circle',
      title: 'Shifts',
      sectionType: ResourceSectionType.Resources,
    },
    {
      link: `/events/${slug}/clusters`,
      iconClasses: 'mi-outlined mi-group-work',
      title: 'Clusters',
      sectionType: ResourceSectionType.Places,
    },
    {
      link: `/events/${slug}/locations`,
      iconClasses: 'mi-outlined mi-location-on',
      title: 'Locations',
      sectionType: ResourceSectionType.Places,
    },
    {
      link: `/events/${slug}/transportation-points`,
      iconClasses: null,
      title: 'Transportation Points',
      sectionType: ResourceSectionType.Places,
      iconText: 'TP',
      colorType: ColorType.Places,
    },
    {
      title: 'Origin X Destination Matrix',
      link: `/events/${slug}/origin-x-destination-matrix`,
      sectionType: ResourceSectionType.Places,
      iconClasses: 'fas fa-fw fa-route',
    },
    {
      link: `/events/${slug}/reports`,
      title: 'Reports',
      sectionType: ResourceSectionType.Resources,
      iconClasses: 'far fa-fw fa-file-excel',
    },
    {
      link: `/events/${slug}/archived-data`,
      title: 'Archived data',
      sectionType: ResourceSectionType.Resources,
      iconClasses: 'fas fa-fw fa-trash-alt',
    },
    {
      title: 'User accesses',
      link: `/events/${slug}/user-accesses`,
      sectionType: ResourceSectionType.Settings,
      iconClasses: 'bi-people-fill',
    },
    // {
    //   link: `/events/${slug}/staging-areas`,
    //   iconClasses: 'mi-outlined mi-workspaces',
    //   title: 'Staging Areas',
    //   sectionType: ResourceSectionType.Places,
    // },
    // {
    //   link: `/events/${slug}/depots`,
    //   iconClasses: 'mi-outlined mi-corporate-fare',
    //   title: 'Depots',
    //   sectionType: ResourceSectionType.Places,
    // },
  ]
}
